<div class="modal-header" ngbAutofocus>
    <h3 class="modal-title">Cancel Holiday Request</h3>
</div>
<div class="modal-body">
    <div class="alert alert-danger">This will cancel your request.</div>

    <div *ngIf="data.FromDate != data.ToDate"><label><strong>Requested Dates: </strong></label> {{data.FromDate}} to {{data.ToDate}}<br /></div>
    <div *ngIf="data.FromDate == data.ToDate"><label><strong>Requested Date: </strong></label> {{data.FromDate}}<br /></div>
    <label><strong>Requested Details: </strong></label> {{data.LeaveDescription}}<br />
    <label><strong>Current Status: </strong></label> {{data.RequestStatus}}<br />
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="confirmClicked()">
        Confirm
    </button>
    <button type="button" class="btn btn-outline-dark" (click)="closeClicked()">
        Close
    </button>
</div>